import { inject, ref } from "vue";
import type { BmFormInterface } from "@/components/controls/BmFormTypes";

/**
 * Vue 3 has unified template and reactive refs, this means that the 'ref' attr needs to be
 * bound to a variable of the same name, and then exposed in the return {} obj of a setup function.
 *
 * https://v3.vuejs.org/guide/composition-api-template-refs.html
 *
 * Initially tries to find form ref in template. If it isn't found, fallback to an injected form
 * instance that is always provided by BmForm.
 */
export const useFormValidator = () => {
  const form = ref<BmFormInterface | null>(null);
  const formFromInject = inject<any>("form", {});

  return {
    form,
    valid: ref(true),
    validate: () => {
      return (form.value ?? formFromInject).validate() as boolean;
    },
    reset: () => {
      return (form.value ?? formFromInject).reset();
    },
    resetValidation: () => {
      return (form.value ?? formFromInject).resetValidation();
    },
  };
};
